import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

const CrmHome = () => import('./CrmHome.vue');

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

// Rota da Tela Início do CRM (dashboard agregado do vendedor)
export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm/home'),
    component: CrmHome,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_home',
        component: CrmHome,
        meta: commonMeta,
      },
    ],
  },
];
